var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9598 47.8543L46.4921 38.3713C46.2485 37.7475 45.7034 37.3618 45.0771 37.3618C44.4509 37.3618 43.9174 37.7475 43.6506 38.394L40.1945 47.8543C40.0321 48.2967 40.2641 48.7845 40.7164 48.9433C41.1687 49.1021 41.6674 48.8752 41.8298 48.4328L42.5488 46.4704H47.5939L48.3129 48.4328C48.4405 48.7845 48.7768 49 49.1364 49C49.2292 49 49.3335 48.9887 49.4263 48.9546C49.8786 48.7958 50.1106 48.3081 49.9482 47.8657L49.9598 47.8543ZM43.1867 44.7576L45.0887 39.551L46.9908 44.7576H43.1867ZM40.2293 34.7869C37.6081 38.8364 35.2422 41.2866 32.366 42.92C32.2268 42.9994 32.076 43.0334 31.9368 43.0334C31.6353 43.0334 31.3453 42.886 31.183 42.6137C30.9394 42.2054 31.0786 41.6836 31.4961 41.4567C33.9316 40.0728 35.9265 38.0878 38.1649 34.7982H30.8698C30.3943 34.7982 30 34.4125 30 33.9475C30 33.4824 30.3943 33.0967 30.8698 33.0967H35.219V30.8507C35.219 30.3857 35.6133 30 36.0888 30C36.5643 30 36.9587 30.3857 36.9587 30.8507V33.0967H41.3079C41.7834 33.0967 42.1777 33.4824 42.1777 33.9475C42.1777 34.4125 41.7834 34.7982 41.3079 34.7982H40.2177L40.2293 34.7869ZM40.2757 43.0334C40.1249 43.0334 39.9741 42.9994 39.8349 42.92C39.0811 42.489 38.3504 42.0125 37.6661 41.5134C37.2834 41.2299 37.2022 40.6967 37.4922 40.3224C37.7821 39.9481 38.3272 39.8687 38.71 40.1522C39.3362 40.6173 40.0205 41.0484 40.7164 41.4454C41.1339 41.6836 41.2731 42.2054 41.0295 42.6137C40.8671 42.886 40.5772 43.0334 40.2757 43.0334Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateInactive);
export default __webpack_public_path__ + "static/media/TranslateInactive.0e44db75977a957e3ab9048023079191.svg";
export { ForwardRef as ReactComponent };